module.exports = __webpack_public_path__ + "static/media/cathedral-high.f5d9f5ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/cathedral-high.jpg
// module id = 616
// module chunks = 0